module.exports = __webpack_public_path__ + "img/delivery.4b394b19.png";